import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MembershipPlan = ({ membership, onUpgrade, onManageBilling }) => {
  const features = {
    free: [
      { text: 'Temel etkinlik erişimi', included: true },
      { text: 'Spot rehberi görüntüleme', included: true },
      { text: 'Topluluk forumu', included: true },
      { text: 'Öncelikli etkinlik kayıtları', included: false },
      { text: 'Özel indirimler', included: false },
      { text: 'Reklamsız deneyim', included: false }
    ],
    pro: [
      { text: 'Tüm ücretsiz özellikler', included: true },
      { text: 'Öncelikli etkinlik kayıtları', included: true },
      { text: '%20 etkinlik indirimi', included: true },
      { text: 'Mağazada %15 indirim', included: true },
      { text: 'Reklamsız deneyim', included: true },
      { text: 'Özel PRO rozetleri', included: true }
    ]
  };

  const currentFeatures = membership?.isPro ? features?.pro : features?.free;

  return (
    <div className="bg-card rounded-xl shadow-organic p-4 md:p-6 lg:p-8">
      <h2 className="text-xl md:text-2xl font-bold text-foreground mb-4 md:mb-6 flex items-center gap-2">
        <Icon name="Crown" size={24} />
        Üyelik Planı
      </h2>
      <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-lg p-4 md:p-6 mb-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <h3 className="text-lg md:text-xl font-bold text-foreground">
                {membership?.isPro ? 'PRO Üyelik' : 'Ücretsiz Üyelik'}
              </h3>
              {membership?.isPro && (
                <div className="bg-accent text-accent-foreground px-2 py-1 rounded text-xs font-semibold">
                  AKTİF
                </div>
              )}
            </div>
            <p className="text-sm md:text-base text-muted-foreground">
              {membership?.isPro
                ? `Sonraki ödeme: ${membership?.nextBillingDate}`
                : 'Daha fazla özellik için PRO\'ya yükseltin'}
            </p>
          </div>
          <div className="text-left sm:text-right">
            <div className="text-2xl md:text-3xl font-bold text-primary">
              {membership?.isPro ? '₺99' : '₺0'}
            </div>
            <div className="text-xs md:text-sm text-muted-foreground">/ ay</div>
          </div>
        </div>

        {membership?.isPro && (
          <div className="bg-card/50 rounded-lg p-3 md:p-4 mb-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs md:text-sm text-muted-foreground">Ödeme Yöntemi</span>
              <span className="text-xs md:text-sm font-semibold text-foreground">
                {membership?.paymentMethod}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-xs md:text-sm text-muted-foreground">Durum</span>
              <span className="text-xs md:text-sm font-semibold text-success">Aktif</span>
            </div>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
          {!membership?.isPro ? (
            <Button
              variant="default"
              size="default"
              iconName="Zap"
              iconPosition="left"
              onClick={onUpgrade}
              fullWidth
            >
              PRO'ya Yükselt
            </Button>
          ) : (
            <>
              <Button
                variant="outline"
                size="default"
                iconName="CreditCard"
                iconPosition="left"
                onClick={onManageBilling}
                fullWidth
              >
                Ödeme Yönetimi
              </Button>
              <Button
                variant="ghost"
                size="default"
                iconName="X"
                iconPosition="left"
                fullWidth
              >
                İptal Et
              </Button>
            </>
          )}
        </div>
      </div>
      <div className="space-y-3">
        <h4 className="text-sm md:text-base font-semibold text-foreground mb-3">
          {membership?.isPro ? 'PRO Özellikleri' : 'Mevcut Özellikler'}
        </h4>
        {currentFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start gap-3">
            <div
              className={`flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center ${
                feature?.included
                  ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
              }`}
            >
              <Icon name={feature?.included ? 'Check' : 'X'} size={14} />
            </div>
            <span
              className={`text-sm md:text-base ${
                feature?.included ? 'text-foreground' : 'text-muted-foreground'
              }`}
            >
              {feature?.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembershipPlan;